import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Grid,
  withStyles,
  Typography,
  Paper,
  LinearProgress,
} from '@material-ui/core'
import withRoot from './withRoot'
import Header from './Header'
import Snackbar from './Snackbar'
import MenuDrawer from 'containers/MenuDrawer'
// import Onboarding from './Onboarding'
import PricingManager from './Pricing'
import { getCustomer } from 'actions/paymentsManager'
import Switch from './Switch'
import {
  currentCredentials,
  currentSession,
  refreshToken,
} from '../actions/auth'
import { getContacts, getContactsWithEmails } from '../actions/contacts'
import { listInbox } from 'actions/inbox'
import { getAllGroups } from '../actions/contacts/groups'
import { loadCreateSchemas } from 'actions/schemas'
import CacheClear from './CacheClear'
import DeleteDialog from './DeleteDialog'
import ErrorsDialog from './ErrorsDialog'
import CreateGroupFromSelectedDialog from './ContactsPage/CreateGroupFromSelectedDialog'
import Button from 'components/theme/Button'
import { userSignOut } from 'actions/auth'
import { ReactComponent as LogoMark } from '../Logo_Mark.svg'
import PhoneCallDialog from './PhoneCallDialog'
import PhoneTime from './PhoneTime'
import Users from './Users'
import ManagePhonesModal from './ManagePhonesModal'
import { list, read, update } from 'actions/data'
import { DndProvider } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import TouchBackend from 'react-dnd-touch-backend'
import MultiBackend, {
  TouchTransition,
  MouseTransition,
} from 'react-dnd-multi-backend'
import RoundRobinDialog from './RoundRobinDialog/'
import VariablesDialog from './TemplateForm/Variables/VariablesDialog'
import LogoManagementAndBranding from './LogoManagementAndBranding'
import ProfileDialog from './ProfileDialog'
import ImageDialog from './ImageDialog'
import DeletePersonalData from './DeletePersonalData'
import LoadingDialog from 'components/Inbox/LoadingDialog'
import IndividualResponseDialog from './IndividualFormResponseDialog'
import InboxAiResponseDialog from './InboxAiResponseDialog'
import ContactDialog from './ContactDialog'
import VastGPT from './VastGPT'
import VerifyEmailDialog from './VerifyEmailDialog'
import PageEditorDialog from './PageEditorDialog'
import { toggleDialog } from 'actions/view'
import ContactListDialog from './ContactListDialog'
import AddOrEditKnowledgeDialog from './AddOrEditKnowledgePage/Dialog'
import A2P10DLC from './A2P10DLC'
import { DATA_API_URL } from 'utils/AllURLs'
import AdvancedSearchDialog from './AdvancedSearchDialog'
import UrlDialog from './UrlDialog'
import AddUseCaseDialog from './ManageCompliance/AddUseCaseDialog'
import { UnreadNotificationsProvider } from 'contexts/UnreadNotifications'
import { AuthenticationObserverProvider } from 'contexts/AuthenticationObserver'
import { DeepLinkHandlerProvider } from 'contexts/DeepLinkHandler'

const CustomHTML5toTouch = {
  backends: [
    {
      backend: HTML5Backend,
      transition: MouseTransition,
      // preview: true,
      // by default, will dispatch a duplicate `mousedown` event when this backend is activated
    },
    {
      backend: TouchBackend,
      // Note that you can call your backends with options
      options: { enableMouseEvents: true },
      preview: true,
      transition: TouchTransition,
    },
  ],
}

const mapStateToProps = state => ({
  location: state.router.location,
  customer: state.paymentsManager.customer,
  loadStatus: state.loadStatus,
  subscriptionStatus: state?.paymentsManager?.subscription?.status,
  session: state.auth.session,
  customVrAccountId:
    state?.auth?.session?.idToken?.payload?.['custom:vr_account_id'],
  customVrRole: state?.auth?.session?.idToken?.payload?.['custom:vr_role'],
  cognitoUsername: state?.auth?.session?.idToken?.payload?.['cognito:username'],
  // verify_my_address_status:
  //   state.data?.['email/verify_my_address_status']?.status,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      currentCredentials,
      currentSession,
      getContacts,
      getAllGroups,
      getContactsWithEmails,
      loadCreateSchemas,
      listInbox,
      refreshToken,
      userSignOut,
      read,
      getCustomer,
      update,
      toggleDialog,
      list,
    },
    dispatch,
  )

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100%',
  },
  appFrame: {
    zIndex: 1,
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    marginLeft: '80px',
    marginTop: '64px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '56px',
      marginLeft: '0px',
    },
  },
  initialForm: {
    border: '1px solid #adadad',
    padding: 20,
    borderRadius: 35,
    // margin: 20,
    position: 'relative',
    height: '100%',
  },
  grid: {
    padding: 24,
  },
  textGrid: {
    [theme.breakpoints.up('md')]: {
      textAlign: 'center',
    },
  },
})

const urlParams = new URLSearchParams(window.location.search)
const jwtToken = urlParams.get('jwtToken')

class App extends Component {
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    console.log(error)
    return { hasError: true }
  }

  constructor(props) {
    super(props)
    this.state = { hasError: false, refreshTokenIterations: null }

    if (!props.loadStatus.schemas) {
      props.loadCreateSchemas()
    }

    props.currentSession()
  }

  componentDidUpdate(prevProps) {
    const { customVrAccountId, customVrRole, customer } = this.props

    if (
      this.props.subscriptionStatus === 'Active' &&
      prevProps.subscriptionStatus !== 'Active' &&
      (jwtToken ||
        (this.isValid() &&
          customVrAccountId &&
          customVrRole &&
          customer &&
          customer.name !== 'notFoundError'))
    ) {
      this.interval = setInterval(() => {
        this.props.read('', 'inbox/last', null, 'none')
      }, 30000)

      this.props
        .read(null, 'email/verify_my_address_status', null, 'none')
        .then(payload => {
          console.log('status payload:', payload)
          if (payload?.status !== 'success') {
            this.props.toggleDialog({ open: true, dialog: 'VerifyEmail' })
          }
        })

      // this.props
      //   .list('a2p10dlc', null, `${DATA_API_URL}/a2p10dlc`)
      //   .then(payload => {
      //     // console.log('a2p10dlc payload', payload)
      //     if (!payload?.response?.length) {
      //       this.props.toggleDialog({ open: true, dialog: 'A2P10DLC' })
      //     }
      //   })

      const devOrProd =
        window?.location?.href?.slice?.(0, 29) ===
        'https://console.vastreach.com'
          ? 'Prod'
          : 'Dev'

      this.props.read('', 'account/preference', null, 'none').then(prefs => {
        if (customVrRole === 'acctowner') {
          this.props.update(
            {
              account_id: customVrAccountId,
              preferences: {
                email_color_foreground: '#d5e6f8',
                email_color_background: '#828282',
                email_color_body_background: '#ffffff',
                email_color_text_header: '#000000',
                email_color_text_paragraph: '#565656',
                email_color_text_link: '#3382ce',
                email_color_button_background: '#014c94',
                email_color_button_text: '#ffffff',
                email_font: 'Arial',
                form_color_foreground: '#d5e6f8',
                form_color_background: '#ffffff',
                form_color_body_background: '#ffffff',
                form_color_text_title: '#000000',
                form_color_text_description: '#000000',
                form_color_text_label: '#014c94',
                form_color_text_label_description: '#014c94',
                form_color_button_background: '#014c94',
                form_color_button_text: '#ffffff',
                form_font: 'Arial',
                company_logo_bgcolor_blackonwhite: '#ffffff',
                company_logo_bgcolor_color: '#016fd9',
                company_logo_bgcolor_whiteonblack: '#000000',
                company_logo_url_email_footer:
                  'https://vastreach.com/static/media/black_logo.dfc96a29.png',
                company_logo_bgcolor_email_footer: '#ffffff',

                company_logo_url_blackonwhite:
                  'https://vastreach.com/static/media/black_logo.dfc96a29.png',
                company_logo_url_color:
                  'https://vastreach.com/static/media/color_logo.3629eb87.png',
                company_logo_url_whiteonblack:
                  'https://vastreach.com/static/media/white_logo.2b133bbf.png',
                ...(prefs?.preferences || {}),
              },
            },
            'account/preference',
            '',
            'account/preference',
            'none',
            null,
            'none',
          )
        }

        if (prefs?.preferences?.default_email_from) {
          this.props.read(
            '',
            'email/verify_default_address_status',
            null,
            'none',
          )
        }

        if (
          jwtToken &&
          window?.ReactNativeWebView?.postMessage &&
          prefs?.preferences?.company_logo_url_color
        ) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              storeProfile: {
                username: this.props.cognitoUsername,
                company_logo_url_color:
                  prefs.preferences.company_logo_url_color,
              },
            }),
          )
        }

        if (!jwtToken) {
          const vastReachProfilesByUsernameString =
            window?.localStorage?.getItem(
              `vastReachProfilesByUsername${devOrProd}`,
            )

          if (vastReachProfilesByUsernameString) {
            const vastReachProfilesByUsername = JSON.parse(
              vastReachProfilesByUsernameString,
            )

            vastReachProfilesByUsername[this.props.cognitoUsername] = {
              ...(vastReachProfilesByUsername?.[this.props.cognitoUsername] ||
                {}),
              username: this.props.cognitoUsername,
              accessToken: this.props.session?.accessToken?.jwtToken,
              refreshToken: this.props.session?.refreshToken?.token,
              idToken: this.props.session?.idToken?.jwtToken,
              company_logo_url_color:
                prefs?.preferences?.company_logo_url_color,
            }

            if (window?.localStorage?.setItem) {
              window.localStorage.setItem(
                `vastReachProfilesByUsername${devOrProd}`,
                JSON.stringify(vastReachProfilesByUsername),
              )
            }
          } else {
            if (window?.localStorage?.setItem) {
              window.localStorage.setItem(
                `vastReachProfilesByUsername${devOrProd}`,
                JSON.stringify({
                  [this.props.cognitoUsername]: {
                    username: this.props.cognitoUsername,
                    accessToken: this.props.session?.accessToken?.jwtToken,
                    refreshToken: this.props.session?.refreshToken?.token,
                    idToken: this.props.session?.idToken?.jwtToken,
                    company_logo_url_color:
                      prefs?.preferences?.company_logo_url_color,
                  },
                }),
              )
            }
          }
        }
      })

      this.props.read('', 'account', null, 'none').then(payload => {
        if (
          jwtToken &&
          window?.ReactNativeWebView?.postMessage &&
          payload?.business_name
        ) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              storeProfile: {
                username: this.props.cognitoUsername,
                business_name: payload.business_name,
              },
            }),
          )
        }

        if (!jwtToken) {
          const vastReachProfilesByUsernameString =
            window?.localStorage?.getItem(
              `vastReachProfilesByUsername${devOrProd}`,
            )

          if (vastReachProfilesByUsernameString) {
            const vastReachProfilesByUsername = JSON.parse(
              vastReachProfilesByUsernameString,
            )

            vastReachProfilesByUsername[this.props.cognitoUsername] = {
              ...(vastReachProfilesByUsername?.[this.props.cognitoUsername] ||
                {}),
              business_name: payload?.business_name,
            }

            if (window?.localStorage?.setItem) {
              window.localStorage.setItem(
                `vastReachProfilesByUsername${devOrProd}`,
                JSON.stringify(vastReachProfilesByUsername),
              )
            }
          }
        }
      })

      this.props.list('a2p10dlc', null, `${DATA_API_URL}/a2p10dlc`)
    }

    let that = this

    if (
      !jwtToken &&
      Boolean(this.props.session) &&
      this.state.refreshTokenIterations === null &&
      (!this.props.customVrAccountId ||
        !this.props.customVrRole ||
        !this.props.customer ||
        this.props.customer.name === 'notFoundError')
    ) {
      console.log('this.props.customer', this.props.customer)
      this.setState({ refreshTokenIterations: 1 })
      this.props.refreshToken()
      this.props.getCustomer()

      // if (customVrAccountId === '111' || customVrAccountId === '220') {
      //   this.props.list(
      //     'twilioService/services',
      //     'sid',
      //     `${DATA_API_URL}/twilioService/services`,
      //   )
      // }

      this.refreshTokenInterval = setInterval(() => {
        console.log('interval')
        this.props.refreshToken()
        this.props.getCustomer()
        this.setState({
          refreshTokenIterations: that.state.refreshTokenIterations + 1,
        })
      }, 30000)
    }
    if (
      this.props.customVrAccountId &&
      this.props.customVrRole &&
      this.props.customer &&
      this.props.customer.name !== 'notFoundError'
    ) {
      clearInterval(this.refreshTokenInterval)
    }

    if (this.props.subscriptionStatus !== 'Active') {
      clearInterval(this.interval)
    }

    if (this.state.refreshTokenIterations >= 45) {
      clearInterval(this.refreshTokenInterval)
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval)
    clearInterval(this.refreshTokenInterval)
  }

  isValid() {
    const { session } = this.props
    if (!Boolean(session)) return false

    const now = Math.floor(new Date() / 1000)
    const adjusted = now - session.clockDrift
    return (
      adjusted < session.accessToken.getExpiration() &&
      adjusted < session.idToken.getExpiration()
    )
  }

  render() {
    const {
      classes,
      location,
      customVrAccountId,
      customVrRole,
      customer,
      cognitoUsername,
    } = this.props

    if (
      (jwtToken && cognitoUsername && customVrAccountId) ||
      (this.props.subscriptionStatus === 'Active' &&
        cognitoUsername &&
        customVrAccountId) ||
      (cognitoUsername &&
        customVrAccountId &&
        customVrRole &&
        customer &&
        customer.name !== 'notFoundError')
    ) {
      return (
        <div className={classes.root}>
          <div className={classes.appFrame}>
            <AuthenticationObserverProvider>
              <DeepLinkHandlerProvider>
                <UnreadNotificationsProvider>
                  <DndProvider
                    backend={MultiBackend}
                    options={CustomHTML5toTouch}
                  >
                    <Header location={location} />
                    <MenuDrawer />
                    <main className={classes.content}>
                      {/* <div className={classes.drawerHeader} /> */}
                      {/* <Onboarding /> */}
                      <CacheClear />
                      <Switch />
                      <DeleteDialog />
                      <Users />
                      <LogoManagementAndBranding />
                      <ManagePhonesModal />
                      <ErrorsDialog />
                    </main>
                    <CreateGroupFromSelectedDialog />
                    <Snackbar />
                    <PricingManager />
                    <PhoneCallDialog />
                    <PhoneTime />
                    <RoundRobinDialog />
                    <VariablesDialog />
                    <ProfileDialog />
                    <ImageDialog />
                    <DeletePersonalData />
                    <LoadingDialog />
                    <IndividualResponseDialog />
                    <InboxAiResponseDialog />
                    <ContactDialog />
                    <VastGPT />
                    <VerifyEmailDialog />
                    <PageEditorDialog />
                    <ContactListDialog />
                    <AddOrEditKnowledgeDialog />
                    <A2P10DLC />
                    <AdvancedSearchDialog />
                    <UrlDialog />
                    <AddUseCaseDialog />
                  </DndProvider>
                </UnreadNotificationsProvider>
              </DeepLinkHandlerProvider>
            </AuthenticationObserverProvider>
          </div>
        </div>
      )
    }

    if (this.state.refreshTokenIterations >= 45) {
      return (
        <div style={{ height: '100%', padding: 20 }}>
          <Paper className={classes.initialForm} elevation={2}>
            <Grid className={classes.grid} container spacing={16}>
              <Grid className={classes.textGrid} item xs={12}>
                <Typography variant="h5" gutterBottom>
                  This is taking longer than expected. Please sign out and try
                  signing back in again in a few minutes. If there are still
                  issues, please contact customer service.
                </Typography>
              </Grid>
            </Grid>
            <Button
              style={{ position: 'absolute', bottom: 8, right: 8 }}
              onClick={() =>
                jwtToken
                  ? window?.ReactNativeWebView?.postMessage?.('signout')
                  : this.props.userSignOut()
              }
              variant="contained"
              color="primary"
            >
              Sign out
            </Button>
          </Paper>
        </div>
      )
    }

    return (
      <div style={{ height: '100%', padding: 20 }}>
        <Paper className={classes.initialForm} elevation={2}>
          <div style={{ textAlign: 'center' }}>
            <LogoMark style={{ height: 40, width: 40, marginTop: 20 }} />
          </div>
          <Grid className={classes.grid} container spacing={16}>
            <Grid className={classes.textGrid} item xs={12}>
              <Typography variant="h5" gutterBottom>
                Initializing Vast Reach. We thank you for your patience.{' '}
                <span role="img" aria-labelledby=":smile:">
                  😄
                </span>
              </Typography>
            </Grid>

            <Grid style={{ textAlign: 'center' }} item xs={12}>
              <LinearProgress />
            </Grid>
            <Typography className={classes.textGrid} gutterBottom>
              <em>
                If this is taking too long (over 5 minutes), try signing out and
                back in.
              </em>
            </Typography>
          </Grid>
          <Button
            style={{ position: 'absolute', bottom: 8, right: 8 }}
            onClick={() => this.props.userSignOut()}
            variant="contained"
            color="primary"
          >
            Sign out
          </Button>
        </Paper>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRoot(withStyles(styles)(App)))
